import React from 'react';
import * as _ from 'lodash';
import * as DOMPurify from 'isomorphic-dompurify';

import { getProcessedCss } from 'tpa-style-webpack-plugin/runtime';

function promisify(fn) {
  return new Promise((resolve, reject) =>
    fn((res) => (res ? resolve(res) : reject({}))),
  );
}
export function withEnhancedStyleLoader(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        styleLoaded: false,
        style: null,
        css: '',
      };
    }
    componentDidMount() {
      this.getWidgetStyle().then(() => this.setState({ styleLoaded: true }));
      if (['editor', 'preview'].indexOf(window.Wix.Utils.getViewMode()) > -1) {
        window.Wix.addEventListener(window.Wix.Events.STYLE_PARAMS_CHANGE, () =>
          this.getWidgetStyle(),
        );
      }
    }

    getWidgetStyle() {
      return Promise.all([
        promisify(window.Wix.Styles.getSiteColors),
        promisify(window.Wix.Styles.getSiteTextPresets),
        promisify(window.Wix.Styles.getStyleParams),
      ])
        .then(([siteColors, siteTextPresets, styleParams]) => {
          const style = {
            siteColors,
            siteTextPresets,
            styleParams,
          };
          const css = getProcessedCss(style, {
            prefixSelector: '',
            isRTL: false,
          });

          return [style, css];
        })
        .then(([style, css]) => {
          this.setState({ style, css });
        });
    }
    render() {
      const clean = DOMPurify.sanitize(this.state.css);

      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
          <style dangerouslySetInnerHTML={{ __html: clean }} />
        </React.Fragment>
      );
    }
  };
}
